module.exports = __webpack_public_path__ + "static/media/icon_logout.b40365d1.svg";